import React from "react";
import { MetricsDashboardGraphDimensionFormat } from "../../../__generated__/api";
import Select from "../../../components/select/Select";

const FORMAT_OPTIONS = [
    { label: "Year", value: MetricsDashboardGraphDimensionFormat.Year },
    { label: "Year/Month", value: MetricsDashboardGraphDimensionFormat.YearMonth },
    { label: "Year/Month/Day", value: MetricsDashboardGraphDimensionFormat.YearMonthDay },
    { label: "Year/Month/Day Hour", value: MetricsDashboardGraphDimensionFormat.YearMonthDayHour },
    { label: "Year/Month/Day Hour:Minute", value: MetricsDashboardGraphDimensionFormat.YearMonthDayHourMinute },

    { label: "Day of Week", value: MetricsDashboardGraphDimensionFormat.DayOfWeek },
    { label: "Hour", value: MetricsDashboardGraphDimensionFormat.Hour },
    { label: "Hour:Minute", value: MetricsDashboardGraphDimensionFormat.HourMinute },
    { label: "UTC Day of Week", value: MetricsDashboardGraphDimensionFormat.UtcDayOfWeek },
    { label: "UTC Hour", value: MetricsDashboardGraphDimensionFormat.UtcHour },
    { label: "UTC Hour:Minute", value: MetricsDashboardGraphDimensionFormat.UtcHourMinute },
];

export default function FormatOptions({
    value, onChange,
}: {
    value: MetricsDashboardGraphDimensionFormat | undefined;
    onChange: (format: MetricsDashboardGraphDimensionFormat) => void;
}) {
    return (
        <Select
            options={FORMAT_OPTIONS}
            value={FORMAT_OPTIONS.find(
                row => row.value === value,
            )}
            onChange={row => onChange(row.value as MetricsDashboardGraphDimensionFormat)}
        />
    );
}
